<template>
  <div class="my_image_animation">
    <ul class="animation_list">
      <li
        class="animation_item"
        v-for="(item, index) in imageAnimationList"
        :key="index"
        :data-active="index === activeIndex"
        @click="change_item(index)"
      >
        <div class="animation_img">
          <div
            v-if="index === 0"
            class="type_img"
          >{{$t('view_left_sidebar_page_setting_full_page_setting_258')}}</div>
          <div
            v-else
            class="type_img"
            :class="`type_img_${index}`"
          ></div>
          <span class="active-icon el-icon-check"></span>
        </div>
        <div class="animation_title">{{ item.typeTitle }}</div>
      </li>
    </ul>
    <div class="animation_setting">
      <div
        class="setting_item setting_radio"
        v-if="imageAnimationList[activeIndex].effects"
      >
        <span class="setting_title">{{$t('components_my_animation_my_image_animation_2290')}}</span>
        <div class="setting_content">
          <el-radio-group v-model="imageAnimationList[activeIndex].formData.effect">
            <el-radio
              :label="index"
              v-for="(item, index) in imageAnimationList[activeIndex].effects"
              :key="index"
            >{{$t(item)}}</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div
        class="setting_item setting_radio"
        v-if="imageAnimationList[activeIndex].direction"
      >
        <span class="setting_title">{{$t('components_my_animation_my_comb_animation_2289')}}</span>
        <div class="setting_content">
          <el-radio-group v-model="imageAnimationList[activeIndex].formData.direction">
            <el-radio
              :label="key"
              v-for="(item, key) in imageAnimationList[activeIndex].direction"
              :key="key"
            >{{$t(item)}}
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <div
        class="setting_item"
        v-if="imageAnimationList[activeIndex].border"
      >
        <my_border
          type="one_level"
          titleWidth="39"
          hiddenIsShow="false"
          :radioValue.sync="imageAnimationList[activeIndex].formData.border.radio_val"
          :colorValue.sync="imageAnimationList[activeIndex].formData.border.custom.borderColor"
          :sliderValue.sync="imageAnimationList[activeIndex].formData.border.custom.borderWidth"
          :max="20"
        >
        </my_border>
      </div>
      <div
        class="setting_item"
        v-if="imageAnimationList[activeIndex].background"
      >
        <my_background
          type="one_level"
          titleWidth="39"
          hiddenIsShow="false"
          :radioValue.sync="imageAnimationList[activeIndex].formData.background.radio_val"
          :colorValue.sync="imageAnimationList[activeIndex].formData.background.custom.color"
        ></my_background>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import imageAnimationList from "@/components/my_animation/image_animation_list"
export default {
  name: 'my_image_animation',
  props: {
    defalutActive: {
      type: Number,
      default: 0
    },
    defaultFormData: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    imageAnimationList: {
      handler (val) {
        this.$emit('change', { typeTitle: val[this.activeIndex].typeTitle, id: val[this.activeIndex].id, formData: val[this.activeIndex].formData })
      },
      deep: true
    },
    activeIndex (val) {
      this.$emit('change', { typeTitle: this.imageAnimationList[val].typeTitle, id: this.imageAnimationList[val].id, formData: this.imageAnimationList[val].formData })
    }
  },
  data () {
    return {
      imageAnimationList: JSON.parse(JSON.stringify(imageAnimationList)),
      activeIndex: this.defalutActive
    }
  },
  mounted () {
    if (this.defaultFormData) {
      this.imageAnimationList[this.activeIndex].formData = this.defaultFormData
    }
    // this.$emit('change', { typeTitle: this.imageAnimationList[this.activeIndex].typeTitle, id: this.imageAnimationList[this.activeIndex].id, formData: this.imageAnimationList[this.activeIndex].formData })
  },
  methods: {
    change_item (index) {
      this.activeIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/css/global-variable.scss";
.my_image_animation {
  .animation_list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-bottom: 22px;
    .animation_item {
      margin: 7px 0;
      .animation_img {
        position: relative;
        margin: 0 5px;
        width: 76px;
        height: 76px;
        border: 1px solid #e1e1e1;
        .active-icon {
          display: none;
          width: 18px;
          height: 16px;
          color: #fff;
          position: absolute;
          bottom: 0;
          right: 0;
          background-color: #5874d8;
          line-height: 22px;
          font-size: 12px;
          padding: 0 3px;
          border-top-left-radius: 100%;
        }
        .type_img {
          width: 100%;
          height: 100%;
          line-height: 76px;
          text-align: center;
          background: url(~@/assets/image/cssSprite.png) no-repeat;
          &.type_img_1 {
            background-position: -47px -831px;
          }
          &.type_img_2 {
            background-position: -123px -831px;
          }
          &.type_img_3 {
            background-position: -199px -831px;
          }
          &.type_img_4 {
            background-position: -275px -831px;
          }
          &.type_img_5 {
            background-position: -351px -831px;
          }
        }
        &:hover {
          border-color: $theme-primary;
        }
      }
      .animation_title {
        text-align: center;
        cursor: pointer;
      }
      &[data-active] {
        .animation_img {
          border-color: $theme-primary;
          .active-icon {
            display: block;
          }
        }
      }
    }
  }
  .animation_setting {
    border-top: 1px dashed #def0ff;
    padding-top: 30px;
    .setting_item {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      .setting_title {
        display: inline-block;
        // width: 50px;
        width: auto;
        text-align: right;
        vertical-align: middle;
        font-size: 13px;
        line-height: 1;
      }
      .setting_content {
        flex: 1;
      }
      &.setting_radio {
        align-items: flex-start;
        .setting_content {
          display: inline-block;
          margin-left: 8px;
          /deep/ .el-radio {
            margin: 0 12px 15px 0;
          }
        }
        &.setting_trigger {
          align-items: center;
          margin-bottom: 15px;
          .setting_content {
            /deep/ .el-radio {
              margin: 0 15px 0 0;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my_animation/my_image_animation.vue